
import { db } from "../../firebaseconf";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import Layout from "../../components/layout";
import Alert from "../../components/alert";
import Preloader from "../../components/preloader";
import Header from "../../components/header";
import { COLLEGE_SEMESTERS } from "../../utils/semesterDefaults";
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    useMediaQuery,
    useTheme,
} from "@mui/material";

export default function UpdateSessionals() {
    const [data] = useState(null);
    const [sessionals, setsessionals] = useState({});
    const [alertVisible, setAlertVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [semesters, setSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState('');
    const [sessionalsubjects, setSessionalSubjects] = useState([]);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
        
        getDocs(subjectsRef).then(snapshot => {
            if (snapshot.empty) {
                // Use fallback semesters if no subjects found
                setSemesters(COLLEGE_SEMESTERS);
            } else {
                const uniqueSemesters = [...new Set(snapshot.docs.map(doc => doc.data().semester))];
                setSemesters(uniqueSemesters.length > 0 ? uniqueSemesters : COLLEGE_SEMESTERS);
            }
        }).catch(err => {
            console.error('Error fetching semesters:', err);
            setSemesters(COLLEGE_SEMESTERS);
        });
    }, []);

    useEffect(() => {
        if (selectedSemester && selectedSubject) {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(
                collection(db, 'institutions', loggedUser.institution_id, 'marks'),
                where('semester', '==', selectedSemester),
                where('subject', '==', selectedSubject)
            );
            getDocs(q).then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data());
                setSessionalSubjects(data);
            });
        }
    }, [selectedSemester, selectedSubject]);

    useEffect(() => {
        if (selectedSemester) {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(
                collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                where('semester', '==', selectedSemester)
            );
            getDocs(q).then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data().name || doc.data().subject_name);
                setSubjects(data);
            });
        }
    }, [selectedSemester]);
    const checksubject = (key) => {
        // eslint-disable-next-line no-useless-escape
        return key.replace(/[./#$\[\]]/g, '_');
    };
    const handlesessionalsChange = (subject, id, value) => {
        const checkedsub = checksubject(subject);
        setsessionals((prev) => ({
            ...prev,
            [id]: {
                ...(prev[id]),
                sessional: {
                    [selectedSemester]: {
                        ...(prev[id]?.sessional?.[selectedSemester]),
                        [selectedSubject]: {
                            ...(prev[id]?.sessional?.[selectedSemester]?.[selectedSubject]),
                            [checkedsub]: value,
                        }
                    }
                }
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) {
                setLoading(false);
                return;
            }
            
            // Batch update sessional marks for all students
            if (data && Array.isArray(data)) {
                for (const student of data) {
                    const studentRef = doc(db, 'institutions', loggedUser.institution_id, 'marks', student.id);
                    await updateDoc(studentRef, {
                        semester: selectedSemester,
                        subject: selectedSubject,
                        sessionalMarks: sessionals[student.id]?.sessional?.[selectedSemester]?.[selectedSubject] || {}
                    });
                }
            }

            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000);
            setTimeout(() => window.location.reload(), 3500);
        } catch (error) {
            console.error("Error updating sessionals:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Update Student Sessionals" />
            <Box sx={{ p: 2 }}>
                {alertVisible && <Alert message="Form submitted successfully!" />}
                {loading && <Preloader />}

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: isSmallScreen ? 'column' : 'row',
                        justifyContent: 'start',
                        gap: 5,
                        mb: 3,
                    }}
                >
                    <FormControl fullWidth={isSmallScreen} sx={{ minWidth: 200 }}>
                        <InputLabel id="semester-label">Select Semester</InputLabel>
                        <Select
                            labelId="semester-label"
                            id="semester"
                            value={selectedSemester}
                            onChange={(e) => setSelectedSemester(e.target.value)}
                            required
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {semesters.map((semester) => (
                                <MenuItem key={semester} value={semester}>
                                    {semester}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {subjects.length > 0 && (
                        <FormControl fullWidth={isSmallScreen} sx={{ minWidth: 200 }}>
                            <InputLabel id="subject-label">Select Subject</InputLabel>
                            <Select
                                labelId="subject-label"
                                id="subject"
                                value={selectedSubject}
                                onChange={(e) => setSelectedSubject(e.target.value)}
                                required
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {subjects.map((subject) => (
                                    <MenuItem key={subject} value={subject}>
                                        {subject}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Box>

                {selectedSubject && (
                    <Box component="form" onSubmit={handleSubmit}>
                        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Roll No</TableCell>
                                        {Object.values(sessionalsubjects).map((sub, idx) => (
                                            <TableCell key={idx}>{sub.subject}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data ? (
                                        Object.keys(data).map((key, index) => (
                                            <TableRow key={key}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{data[key].Name}</TableCell>
                                                <TableCell>{data[key].rollNo}</TableCell>
                                                {Object.values(sessionalsubjects).map((sub, idx) => (
                                                    <TableCell key={idx}>
                                                        <TextField
                                                            type="text"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth={isSmallScreen}
                                                            onChange={(e) =>
                                                                handlesessionalsChange(sub.subject, key, e.target.value)
                                                            }

                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} align="center">
                                                Loading data...
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
                            <Button variant="contained" color="primary" type="submit">
                                Submit
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        </Layout>
    );
}
